import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { OnboardingResponseStatus } from 'clickNgo/configs/service/onboarding'
import { ContactWorkflowStatus, IContact } from 'clickNgo/entities/contact'
import { updateContact } from 'clickNgo/entities/contact/api'
import { getJSendErrorMessages } from 'clickNgo/helpers/api'
import Logger from 'core/utils/Logger'

export type ContactRoles = {
  contact: IContact
  rolesForRemoving: string[]
}

export const removeContactRoles = async (
  contactsWithRolesToRemove: ContactRoles[]
): Promise<void> => {
  for (const { contact, rolesForRemoving } of contactsWithRolesToRemove) {
    try {
      const updatedRoles = (contact.hpRoles ?? []).filter(
        (role) => !rolesForRemoving.includes(role)
      )

      const response = await updateContact(
        {
          ...contact,
          hpRoles: updatedRoles,
          modifiedValues: ['hpRoles'],
          source: ProfilingRequestSource.ClickAndGoPortal,
          workflowStatus: ContactWorkflowStatus.New,
        },
        { forceRoles: true }
      )

      if (response.status === OnboardingResponseStatus.Error) {
        const { message, status } = response
        Logger.error({ message, status })
        throw new Error(message)
      }

      if (response.status === OnboardingResponseStatus.Fail) {
        const message = getJSendErrorMessages(response).join(', ')
        const status = response.status
        Logger.error({ message, status })
        throw new Error(message)
      }
    } catch (err) {
      Logger.error('Error removing contact roles', err)
      throw err
    }
  }
}
